import {Button, Col, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Back from "../layout/template/back";
import {Link, useNavigate, useParams} from 'react-router-dom';
import LogoSwiss from "../../img/swiss_acquatics_logo.png"
import APIService from "../../services/ApiService";
import DateTimeUtils from "../../services/DateTimeUtils";


const Course = () => {

    const navigate = useNavigate();
    const [course, setCourse] = useState([]);
    const [livello, setLivello] = useState();
    const [dayList, setDayList] = useState([])
    const [piscina, setPiscina] = useState()
    const [loading, setLoading] = useState(true);
    const {id} = useParams();

    useEffect(() => {
        APIService.getCourseById(id).then(async (jOb) => {
            let livelloReq = jOb.levelCourseId ? await APIService.getLevelById(jOb.levelCourseId).catch(() => null) : null
            let daysListReq = await APIService.getDaysForCourse(jOb.id).catch(() => [])
            let piscinaReq = jOb.piscinaId ? await APIService.getPoolById(jOb.piscinaId).catch(() => null) : null
            setLivello(livelloReq)
            setDayList(daysListReq)
            setPiscina(piscinaReq)
            setCourse(jOb);
        }).catch(() => {}).finally(() => setLoading(false))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Un corso e' iscrivibile solo dentro la sua finestra di visibilita' (stesso
    // criterio della lista lato server): visibilityStart <= ora <= visibilityEnd.
    // Cosi i corsi vecchi/chiusi non sono piu iscrivibili cambiando l'ID nell'URL.
    const isCourseOpen = (c) => {
        if (!c || !c.visibilityStart || !c.visibilityEnd) return false;
        const now = new Date();
        const parse = (s) => new Date(String(s).replace(' ', 'T'));
        return now >= parse(c.visibilityStart) && now <= parse(c.visibilityEnd);
    };


    const getDate = () => {
        let date = '';
        if (course.start !== undefined) {
            date = course.start.split(' ')[0];
            let year = date.split('-')[0];
            let month = date.split('-')[1];
            let day = date.split('-')[2];
            date = day + '.' + month + '.' + year
        }
        return (date)
    }

    const handleSubcription = () =>{
        navigate("/shop/booking/"+id);
    }


    return (
        <>
            <Row className={'justify-content-between'}>
                <Col xs={12} lg={6}>
                    <Row>
                        <Col>
                            <Back/>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={'title-page-section mt-5 header-detail'}>
                                <h2 className={'title'}>{course.title} {course.piscina},
                                    Livello {livello && livello.level}</h2>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={'paragraph-section'}>
                                <p className={'fw-bold mb-0'}>Periodo di svolgimento:</p>
                                <p>dal {getDate()}</p>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <table className="table table-columns-border">
                                <thead>
                                <tr>
                                    <th scope={'col'}>Giorno</th>
                                    <th scope={'col'}>Data</th>
                                    <th scope={'col'}>Ora</th>
                                </tr>
                                </thead>
                                <tbody>

                                {dayList.length > 0 ?
                                    dayList.map((day, index) =>
                                        <tr>
                                            <td>{DateTimeUtils.fromDateToDayOfWeek(day.day)}</td>
                                            <td>{DateTimeUtils.formatStartStringAsDate(day.day)}</td>
                                            <td>
                                                {day.pause
                                                    ? "Pause"
                                                    : (day.start ? DateTimeUtils.convertUTCToLocalTime(day.start) : "") +
                                                    (day.start && day.end ? " - " : "") +
                                                    (day.end ? DateTimeUtils.convertUTCToLocalTime(day.end) : "")
                                                }
                                            </td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                </tbody>
                            </table>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <div className={'paragraph-section'}>
                                <p className={'fw-bold mb-0'}>Numero lezioni:</p>
                                <p>{course.noOfLessons} lezioni</p>
                            </div>

                            {piscina &&
                                <div className={'paragraph-section'}>
                                    <p className={'fw-bold mb-0'}>Luogo:</p>
                                    <p className={'mb-0'}>Piscina {piscina.title}</p>
                                    <p><Link to={`/shop/course/${id}/pool/${piscina.id}`} replace><i className={"icon arrow me-1"}/>vedi dettagli sulla piscina</Link></p>
                                </div>
                            }


                            <div className={'paragraph-section'}>
                                <p className={'fw-bold mb-0'}>Categoria:</p>
                                <p className={'mb-0'}>{livello && livello.level}{livello && livello.level === "LIV 0" ? ", dai 3 ai 4 anni" : ""}</p>
                            </div>

                            <div className={'paragraph-section'}>
                                <p className={'fw-bold mb-0'}>Monitori:</p>
                                <p className={'mb-0'}>qualificati G+S e formazione Swiss Acquatics</p>
                                <img src={LogoSwiss} alt={'Swiss aquatics logo certification'} className="img-fluid"
                                     width="220"/>
                            </div>

                            <div className={'paragraph-section'}>
                                <p className={'fw-bold mb-0'}>Sconti:</p>
                                <p>Nel caso di acquisto di più corsi per fratelli o in caso di acquisto ad entrambi i cicli, viene applicato uno sconto del 10% direttamente al momento del pagamento.
                                    Nel caso di iscrizione al 2° ciclo in un momento successivo, il buono sconto può essere richiesto per email al responsabile e va immesso nello shop al momento del pagamento.
                                    Email per la richiesta del buono ed eventuali domande a: <a href="mailto:corsi@nuotosportlocarno.ch">corsi@nuotosportlocarno.ch</a></p>

                            </div>

                            <div className={'paragraph-section'}>
                                <p className={'fw-bold mb-0'}>Per ulteriori informazioni:</p>
                                <p className={'mb-0'}>corsi@nuotosportlocarno.ch</p>
                                <p>+41 79 207 14 65</p>
                            </div>
                        </Col>
                    </Row>
                </Col>
                {/* end side left*/}

                {/*side right*/}
                <Col xs={12} lg={5} xl={5}>

                    <div className="sticky-top-custom">
                        {loading ? null : (isCourseOpen(course) ?
                            <>
                                <h2 className={'title title-table mt-3'}>Iscriviti</h2>
                                <table className="table">
                                    <thead>
                                    <tr>
                                        <th scope={'col'}>Corso</th>
                                        <th scope={'col'}>Prezzo</th>
                                        <th scope={'col'} className={'text-end'}></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>{course.title}, <br/> Livello {livello && livello.level}</td>
                                        <td>{parseFloat(course.price).toFixed(2)} CHF</td>
                                        <td className={'text-end'}><Button className={'btn-table'} onClick={handleSubcription}>Iscriviti</Button></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </>
                            :
                            <div className={'alert alert-warning mt-3'}>
                                <p className={'fw-bold mb-1'}>Iscrizioni non disponibili</p>
                                <p className={'mb-0'}>Questo corso non è al momento disponibile per l'iscrizione.
                                    Trovi i corsi attivi nella <Link to={'/shop'}>pagina dei corsi</Link>.</p>
                            </div>
                        )}
                    </div>

                </Col>
                {/*side right*/}
            </Row>
        </>

    );

}
export default Course;
